import React from "react";
const Header = () => {
  return (
    <header className="header">
      <nav className="header-menu">
        <ul>
          <li>Home</li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;
